export default __webpack_public_path__ + "static/media/Profile.c77fb506.jpeg";